import type { ColumnFiltersState } from '@tanstack/react-table'
import type { ColumnDefinition } from './types'

export function columnFilterHasValue(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.length > 0
  }
  return value != null && value !== ''
}

export function getActiveFilterColumnIds(
  columnFilters: ColumnFiltersState,
): Set<string> {
  const ids = new Set<string>()
  for (const f of columnFilters) {
    if (columnFilterHasValue(f.value)) {
      ids.add(f.id)
    }
  }
  return ids
}

/** Toolbar filter chips: visible in config menu OR currently applied. */
export function resolveFilterableColumns<TRow>(
  columns: ColumnDefinition<TRow>[],
  visibleFilterIds: string[],
  columnFilters: ColumnFiltersState,
): ColumnDefinition<TRow>[] {
  const activeFilterIds = getActiveFilterColumnIds(columnFilters)
  return columns.filter(
    (c) =>
      c.filterType &&
      (visibleFilterIds.includes(c.id) || activeFilterIds.has(c.id)),
  )
}
